import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const ScriptLoader = () => {
  const location = useLocation();
  const [config, setConfig] = useState({});

  const getConfigData = async () => {
    try {
      const res = await fetch("/root/getConfig");
      if (!res.ok) {
        throw new Error(`HTTP error: ${res.status}`);
      }
      const data = await res.json();
      return data;
    } catch (err) {
      console.error("Error loading config:", err);
      return {};
    }
  };

  useEffect(() => {
    const getData = async () => {
      const data = await getConfigData();
      setConfig(data);
    };
    getData();
  }, []);

  useEffect(() => {
    if (!config?.ANALYTICS_SCRIPT) return;
    const script = document.createElement("script");
    script.src = config.ANALYTICS_SCRIPT;
    script.type = "text/javascript";

    if (!document.querySelector(`script[src="${script.src}"]`)) {
      document.head.appendChild(script);
    }
  }, [config, location]);

  return null;
};

export default ScriptLoader;
